// `audio.music`: a track from a prompt (G7-sound-types).
// Live's Sounds page chip; the Sounds forms build these. Sound takes no source.
import { AudioMusicQuote, AudioMusicRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"audio.music"> = {
  type: "audio.music",
  label: "Music",
  source: "form",
  pair: "audio.music",
  fields: (draft) => commonFields(draft),
  request: AudioMusicRequest,
  quote: AudioMusicQuote,
};
